import { useMutation } from "@tanstack/react-query";

import { ResponseType } from "../../../utils/types";
import { AuthApiService } from "../../../apiService/auth-services.ts";
import NotificationService from "../../../services/NotificationService";
import {
  OtpResetPayload,
  ResendOtpPayload,
} from "../Login/types";

export const useVerifyUserOtp = (
  onSuccess: (data: any, payload: OtpResetPayload) => void
) => {
  return useMutation<ResponseType, Error, OtpResetPayload>({
    mutationFn: (payload: OtpResetPayload) =>
      AuthApiService.otpRegisterUser(payload),
    onSuccess: (
      { ok, response, data }: ResponseType,
      payload: OtpResetPayload
    ) => {
      if (ok) {
        onSuccess(data, payload);
        return data;
      }
      NotificationService.error(data?.data?.metadata?.message);
      throw response.message;
    },
    onError: (err: any) => {
      throw err;
    },
  });
};

export const useResendOtp = (onSuccess: () => void) => {
  return useMutation<ResponseType, Error, ResendOtpPayload>({
    mutationFn: (payload: ResendOtpPayload) =>
      AuthApiService.resendOtp(payload),
    onSuccess: (
      { ok, response, data }: ResponseType,
      payload: ResendOtpPayload
    ) => {
      if (ok) {
        onSuccess();
        NotificationService.success(
          "OTP for verification has been resent to your email successfully."
        );
        return data;
      }
      NotificationService.error(data?.data?.metadata?.message);
      throw response.message;
    },
    onError: (err: any) => {
      throw err;
    },
  });
};
